import { prepareBaseResponse } from "./prepareBaseResponse";
import { MessageTypes } from "../messageTypesEnum";
import { Config, ConfigPhone, Match } from "refsix-js-models";
import { store } from "../../../redux/store";
import { WatchMessage } from "../watchInterface";
import { hasFeatureAccess } from "../../subscriptionService";
import { createDefaultTeamOfficials } from "../../TeamOfficialsService";
import { buildMatchForWatch } from "refsix-core";

interface MatchResponse extends WatchMessage {
    match: Match;
    config: Config;
}

export async function getMatch(
    data: any,
    token: any
): Promise<MatchResponse | undefined> {
    const matchId = data.matchId;
    const state = store.getState();
    const settings = state.settings?.settings || ConfigPhone.defaultConfig();
    const match = state.matches.matches.find((m) => m._id === matchId);

    const matchData = buildMatchForWatch(
        match,
        settings,
        hasFeatureAccess("timers"),
        true,
        createDefaultTeamOfficials(),
        false
    );

    let response: MatchResponse = {
        ...prepareBaseResponse(
            {
                requestId: data.id,
                match: matchData,
            },
            MessageTypes.GET_MATCH_RESPONSE,
            data,
            token
        ),
        match: matchData.match,
        config: matchData.config,
    };

    return response;
}
